export default "__VITE_ASSET__DNdxDM8l__"